import graphql__74086c612363d81ad992 from "./__generated__/CityWalkLayout_cityWalk.graphql.js";import { useCallback, useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector, useDispatch } from "react-redux";
import { Outlet } from "react-router";
import find from "lodash/find";

import MapWithSidebarLayout from "../Maps/MapWithSidebarLayout";
import { useResourcesList } from "../ResourcesList/resourcesList";
import { useNavigateTo } from "../Routes/RoutesContext";
import CityWalkCompleteDialog from "./CityWalkCompleteDialog";
import CityWalkComplete from "./CityWalkComplete";
import MapViewerPosition from "../Maps/MapViewerPosition";
import { NonDesktop } from "../Utils/ResponsiveQueries";
import { MAP_ITEM_TYPE_ELEMENT, useMapContext } from "../Maps/MapContext";
import { selectedItem } from "../Utils/resourcesList";

import {
  setCityWalkWaypointsCount,
  setCityWalkCurrentWaypoint
} from "../../reducers/cityWalks";
import { selectItem } from "../../reducers/resourcesList/selection";

const CityWalkLayout = props => {
  const cityWalk = useFragment(CityWalkLayout_cityWalk, props.cityWalk);
  const {
    slug: participativeModuleSlug,
    waypoints,
    waypointsCount,
    activeContribution
  } = cityWalk;

  const { mapKey } = useMapContext();
  const resourcesList = useResourcesList();
  const { resourcesListKey } = resourcesList;

  const isActive = useSelector(({ map }) => !!map[mapKey].cityWalk.isActive);
  const completeDialogActive = useSelector(
    ({ map }) => map[mapKey].cityWalk.completeDialogActive
  );

  // Use the current waypoint stored in the redux store, if there's a current waypoint,
  // and find its data in the city walks waypoint data
  const currentWaypoint = useSelector(({ map }) => {
    const currentWaypointId = map[mapKey].cityWalk.currentWaypoint?.id;
    return (
      currentWaypointId && find(waypoints, waypoint => waypoint.id === currentWaypointId)
    );
  });

  const currentWaypointId = currentWaypoint?.id;
  const currentWaypointElementId = currentWaypoint?.element?.id;

  const waypointFromElementId = useCallback(
    elementId => {
      return find(waypoints, ({ element }) => element.id === elementId);
    },
    [waypoints]
  );

  const { itemId, itemType } = selectedItem(resourcesList);
  const selectedWaypointId =
    itemId && itemType === MAP_ITEM_TYPE_ELEMENT && waypointFromElementId(itemId)?.id;

  let dialog;

  if (completeDialogActive) {
    dialog = <CityWalkCompleteDialog cityWalk={cityWalk} />;
  } else if (activeContribution && activeContribution.isComplete) {
    dialog = <CityWalkComplete cityWalk={cityWalk} />;
  }

  const dispatch = useDispatch();

  const selectWaypointIfURLMatches = useCallback(() => {
    if (!currentWaypointId) return;

    if (!selectedWaypointId || selectedWaypointId !== currentWaypointId) {
      dispatch(
        selectItem(resourcesListKey, currentWaypointElementId, MAP_ITEM_TYPE_ELEMENT)
      );
    }
  }, [
    currentWaypointElementId,
    currentWaypointId,
    dispatch,
    resourcesListKey,
    selectedWaypointId
  ]);

  useEffect(() => {
    dispatch(setCityWalkWaypointsCount(mapKey, waypointsCount));
  }, [dispatch, mapKey, waypointsCount]);

  useEffect(() => {
    selectWaypointIfURLMatches();
  }, [selectWaypointIfURLMatches]);

  const navigateTo = useNavigateTo();

  const handleMapElementClicked = useCallback(
    (_e, { elementId }) => {
      const waypoint = waypointFromElementId(elementId);

      if (!waypoint) return;

      const cityWalkWaypointId = waypoint.id;

      dispatch(setCityWalkCurrentWaypoint(mapKey, waypoint));
      navigateTo("cityWalkWaypoint", { participativeModuleSlug, cityWalkWaypointId });
    },
    [participativeModuleSlug, dispatch, mapKey, navigateTo, waypointFromElementId]
  );

  return (
    <MapWithSidebarLayout map={cityWalk} onElementClick={handleMapElementClicked}>
      {dialog || <Outlet />}

      {/* Ask viewer position and display it for non-desktop platforms */}
      <NonDesktop>{isActive && <MapViewerPosition />}</NonDesktop>
    </MapWithSidebarLayout>
  );
};

const CityWalkLayout_cityWalk = graphql__74086c612363d81ad992;

export default CityWalkLayout;
